import api from './api';

const BASE = '/email';

export type EmailDeliveryMode = 'send' | 'allowlist' | 'suppress';

export interface EmailTechnicalConfig {
  ses_region: string;
  ses_from_email: string;
  email_delivery_mode: EmailDeliveryMode;
  notification_recipient_allowlist: string;
  ses_access_key_id_in_database: boolean;
  ses_secret_access_key_in_database: boolean;
  env_aws_ses_region: string;
  env_aws_ses_from_email: string;
  env_email_delivery_mode: EmailDeliveryMode;
}

export type EmailTechnicalConfigUpdate = {
  ses_region?: string | null;
  ses_from_email?: string | null;
  ses_access_key_id?: string | null;
  ses_secret_access_key?: string | null;
  email_delivery_mode?: EmailDeliveryMode | null;
  notification_recipient_allowlist?: string | null;
};

export const emailAdminService = {
  getTechnicalConfig: (): Promise<EmailTechnicalConfig> =>
    api.get(`${BASE}/admin/technical-config`).then((r) => r.data),

  putTechnicalConfig: (data: EmailTechnicalConfigUpdate): Promise<EmailTechnicalConfig> =>
    api.put(`${BASE}/admin/technical-config`, data).then((r) => r.data),
};
